import React from 'react';

import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';

import { Container, Text } from './OpenClosedStatusComponent.styled';
import { OpenClosedStatusComponentProps } from './OpenClosedStatusComponent.types';

export const OpenClosedStatusComponentView: React.FC<OpenClosedStatusComponentProps> =
  ({ isClosed }: OpenClosedStatusComponentProps) => {
    return (
      <Container>
        {isClosed && (
          <>
            <CheckCircleIcon
              primaryColor='var(--ds-text-subtle, var(--ds-fb-text-subtle))'
              size='small'
              label='closed'
            />
            <Text>Closed</Text>
          </>
        )}
        {!isClosed && 'Open'}
      </Container>
    );
  };
